export const BUSINESS_REPORTS_TAGS = {
  BUSINESS_REPORTS_TAG: "BusinessReports",
  BUSINESS_REPORTS_OUTCOME_TAG: "BusinessReportsOutcome",
  BUSINESS_REPORTS_OUTCOME_SEARCH_TAG: "BusinessReportsOutcomeSearch",
  PIVOT_FIELD_SCHEMA_TAG: "PivotFieldSchema",
  SNAPSHOT_EVENTS_TAG: "SnapshotEvents",
  COLUMN_ANALYSIS_TAG: "ColumnAnalysis",
  SNAPSHOT_CONVERSATION_TAG: "SnapshotConversation",
  TEMPLATE_CATEGORIES_TAG: "TemplateCategories",
  TEMPLATE_FAVORITES_TAG: "TemplateFavorites",
  SNAPSHOT_EVENT_MAILS_TAG: "SnapshotEventMails",
};
